import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import ChartBlockNode from './ChartBlockNode.vue'
import LZS from 'lz-string'

export default Node.create({
  name: 'chart-block',
  group: 'block',
  inline: false,
  atom: true,

  addAttributes() {
    return {
      serialized: {
        default: {},
        // Decode and Parse
        parseHTML: element => {
          const raw = element.getAttribute('serialized')
          if (!raw) return {}
          try {
            const decompressed = LZS.decompressFromEncodedURIComponent(raw)
            return JSON.parse(decompressed || '{}')
          } catch (e) {
            console.error('Failed to parse chart data', e)
            return {}
          }
        },
        renderHTML: attributes => {
          if (!attributes.serialized) return {}
          const jsonString = JSON.stringify(attributes.serialized)
          const compressed = LZS.compressToEncodedURIComponent(jsonString)
          return {
            serialized: compressed,
          }
        },
      },
    }
  },

  parseHTML() {
    return [{ tag: 'chart-block' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['chart-block', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(ChartBlockNode)
  },
})
